<template>
  <div>
    <NuxtLoadingIndicator
      color="black"
      :height="2"
    />
    <div class="nuxt-body">
      <AppIndex />
    </div>
  </div>
</template>
